import { User } from "../types";

export type SignupFormFields = {
  name: string;
  email: string;
  password: string;
  birth_date: string;
  phone: string;
  professional_id?: number;
};

/**
 * Payload alinhado a POST /users/register/ e ao modal de profissional.
 */
export function buildRegisterPayload(
  fields: SignupFormFields,
  options?: { is_professional?: boolean; color?: string; photo?: string },
): Partial<User> & {
  password: string;
  professional_id?: number;
} {
  const phoneDigits = fields.phone.replace(/\D/g, "");
  return {
    name: fields.name.trim(),
    email: fields.email.trim().toLowerCase(),
    password: fields.password,
    birth_date: fields.birth_date,
    phone: phoneDigits,
    is_professional: options?.is_professional ?? false,
    color: options?.color ?? "",
    photo: options?.photo ?? "",
    ...(fields.professional_id
      ? { professional_id: fields.professional_id }
      : {}),
  };
}

/** Converte idade em anos para birth_date aproximado (YYYY-01-01). */
export function birthDateFromAge(age: number): string {
  const year = new Date().getFullYear() - age;
  return `${year}-01-01`;
}
